import { Box, Button, CircularProgress } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { SLATE } from "../constants/Colors";

const BUTTON_SX = {
  textTransform: "none",
  fontSize: "0.875rem",
  fontWeight: 500,
  boxShadow: "none",
  px: 2,
};

/**
 * Fixed bottom action bar used across all create/edit forms.
 *
 * Legacy props (backward compatible):
 *   handleSave, cancelRedirectUrl, handleCancel, disabledSave, name, buttons
 *
 * New props:
 *   saving   — shows spinner and disables save button while true
 *   isDirty  — when provided, also disables save button when false
 */
export default function BottomActionBar({
  name = "Save",
  handleSave,
  handleCancel,
  cancelRedirectUrl = "",
  disabledSave = false,
  saving = false,
  isDirty,
  buttons,
}) {
  const isSaveDisabled = disabledSave || saving || (isDirty !== undefined && !isDirty);

  let cancelButtonProps = {};
  if (handleCancel !== undefined) cancelButtonProps.onClick = () => handleCancel();
  if (cancelRedirectUrl !== "") {
    cancelButtonProps.component = Link;
    cancelButtonProps.to = cancelRedirectUrl;
  }

  return (
    <footer className="bottom-footer">
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 1.5,
          py: 1.5,
        }}
      >
        {(cancelRedirectUrl !== "" || handleCancel !== undefined) && (
          <Button
            variant="outlined"
            {...cancelButtonProps}
            sx={{
              ...BUTTON_SX,
              borderColor: SLATE[300],
              color: SLATE[700],
              "&:hover": { borderColor: SLATE[400], bgcolor: SLATE[50], boxShadow: "none" },
            }}
          >
            Cancel
          </Button>
        )}

        {buttons !== undefined &&
          buttons.map((button) => (
            <Button
              key={button.name}
              disabled={button.disabledSave}
              variant="contained"
              onClick={() => button.onClick("production")}
              sx={{
                ...BUTTON_SX,
                "&:hover": { boxShadow: "none" },
              }}
            >
              {button.name}
            </Button>
          ))}

        <Button
          disabled={isSaveDisabled}
          variant="contained"
          // Use type="submit" when no handleSave is provided (form-based submission)
          type={handleSave ? "button" : "submit"}
          onClick={handleSave ? () => handleSave() : undefined}
          sx={{
            ...BUTTON_SX,
            "&:hover": { boxShadow: "none" },
          }}
        >
          {saving && <CircularProgress size={16} sx={{ color: "#fff", mr: 1 }} />}
          {name}
        </Button>
      </Box>
    </footer>
  );
}
